export { OneTrustButton } from './legacy';
export { OneTrustV2 } from './OneTrust.v2';
export { OneTrustHeadScriptV2 } from './OneTrustHeadScript.v2';
export { OneTrustScripts } from './OneTrustScripts';
